import { IClient } from "../../models/client/response";
import { IDiscountCodeQuery } from "../../models/discount-code/query";
import {
  IDiscountCode,
  IDiscountCodeClient,
  IDiscountCodeDetails,
} from "../../models/discount-code/response";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import toggleLoading from "../../utils/helpers/xor";
import paramsReducer from "../base/base-reducer";
import { QueryAction } from "../base/base-reducer";
import { IInternalState, DiscountCodeLoading } from "./context";

type Action =
  | {
      type: "LOADING";
      payload: { loading: DiscountCodeLoading | DiscountCodeLoading[] };
    }
  | { type: "SET_LIST"; payload: { list: IBaseListingResponse<IDiscountCode> } }
  | {
      type: "SET_CLIENT";
      payload: { clientsList: IBaseListingResponse<IDiscountCodeClient> };
    }
  | { type: "SET_DETAILS"; payload: { details?: IDiscountCodeDetails } }
  | QueryAction<IDiscountCodeQuery>;

const reducer = (state: IInternalState, action: Action): IInternalState => {
  switch (action.type) {
    case "LOADING": {
      return {
        ...state,
        loading: toggleLoading(state.loading, action.payload.loading),
      };
    }
    case "SET_CLIENT": {
      return {
        ...state,
        clientsList: action.payload.clientsList,
      };
    }
    case "SET_LIST": {
      return {
        ...state,
        list: action.payload.list,
      };
    }
    case "SET_DETAILS": {
      return {
        ...state,
        details: action.payload.details,
      };
    }

    default: {
      return paramsReducer(state, action);
    }
  }
};

export default reducer;
